<script setup lang="ts">
import GlobalModal from "~/components/Common/Modals/GlobalModal.vue";
import LoaderWithText from "~/components/Common/LoaderWithText.vue";
</script>

<template>
  <GlobalModal>
    <template #body>
      <LoaderWithText class="h-full" />
    </template>
  </GlobalModal>
</template>
